let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("khxy3")).then(() => parcelRequire('1O92x'));